namespace GeniuzPOS.PosShift {
    export namespace PsEndDayCashierService {
        export const baseUrl = 'PosShift/PsEndDayCashier';

        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsEndDayCashierRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsEndDayCashierRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Retrieve = "PosShift/PsEndDayCashier/Retrieve",
            List = "PosShift/PsEndDayCashier/List"
        }

        [
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PsEndDayCashierService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
